// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --accentColor: #008ef4;
  --accentLightColor: rgba(0, 142, 244, 0.1);
  --textOnAcccentColor: white;
  --backgroundColor: #f5f5f5;
  --backgroudSecondaryColor: white;
  --textColor: black;
  --textSecondaryColor: gray;
  --errorColor: red;
  --grayColor: #0000007a;
  --grayLightColor: #0000002b;
  --grayOnAccentColor: #ffffffdb;
  --grayLightOnAccentColor: #ffffff3a;
}

.modal_modalContainer__6bxsb {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 200;
  padding: 20px;
  backdrop-filter: blur(1px);
}
.modal_modalContainer__6bxsb .modal_modal__XhTq8 {
  background-color: var(--backgroundColor);
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  min-width: 400px;
  max-width: 90%;
  padding: 20px;
}
.modal_modalContainer__6bxsb .modal_modal__XhTq8 .modal_header__oe722 {
  margin-bottom: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid var(--backgroudSecondaryColor);
}
.modal_modalContainer__6bxsb .modal_modal__XhTq8 .modal_header__oe722 .modal_title__0XpA9 {
  font-weight: 500;
}
.modal_modalContainer__6bxsb .modal_modal__XhTq8 .modal_body__SQUnU {
  padding: 10px;
  margin-bottom: 10px;
}
.modal_modalContainer__6bxsb .modal_modal__XhTq8 .modal_footer__GKw2U {
  display: flex;
  justify-content: flex-end;
}
.modal_modalContainer__6bxsb .modal_modal__XhTq8 .modal_footer__GKw2U button {
  all: unset;
  background-color: var(--accentColor);
  color: var(--textOnAcccentColor);
  padding: 7px 10px;
  border-radius: 5px;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/styles/vars.scss","webpack://./src/components/modal/modal.module.scss"],"names":[],"mappings":"AAEA;EACE,sBAAA;EACA,0CAAA;EACA,2BAAA;EACA,0BAAA;EACA,gCAAA;EACA,kBAAA;EACA,0BAAA;EACA,iBAAA;EACA,sBAAA;EACA,2BAAA;EACA,8BAAA;EACA,mCAAA;ACDF;;AAXA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,aAAA;EACA,oCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,0BAAA;AAcF;AAZE;EACE,wCAAA;EACA,kBAAA;EACA,wCAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;AAcJ;AAZI;EACE,mBAAA;EACA,oBAAA;EACA,uDAAA;AAcN;AAZM;EACE,gBAAA;AAcR;AAVI;EACE,aAAA;EACA,mBAAA;AAYN;AATI;EACE,aAAA;EACA,yBAAA;AAWN;AATM;EACE,UAAA;EACA,oCAAA;EACA,gCAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;AAWR","sourcesContent":["$mobileBP: 900px;\n\n:root {\n  --accentColor: #008ef4;\n  --accentLightColor: rgba(0, 142, 244, 0.1);\n  --textOnAcccentColor: white;\n  --backgroundColor: #f5f5f5;\n  --backgroudSecondaryColor: white;\n  --textColor: black;\n  --textSecondaryColor: gray;\n  --errorColor: red;\n  --grayColor: #0000007a;\n  --grayLightColor: #0000002b;\n  --grayOnAccentColor: #ffffffdb;\n  --grayLightOnAccentColor: #ffffff3a;\n}\n","@import '../../styles/vars.scss';\n\n.modalContainer {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background-color: rgba(0, 0, 0, 0.7);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 200;\n  padding: 20px;\n  backdrop-filter: blur(1px);\n\n  .modal {\n    background-color: var(--backgroundColor);\n    border-radius: 8px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n    min-width: 400px;\n    max-width: 90%;\n    padding: 20px;\n\n    .header {\n      margin-bottom: 10px;\n      padding-bottom: 10px;\n      border-bottom: 1px solid var(--backgroudSecondaryColor);\n\n      .title {\n        font-weight: 500;\n      }\n    }\n\n    .body {\n      padding: 10px;\n      margin-bottom: 10px;\n    }\n\n    .footer {\n      display: flex;\n      justify-content: flex-end;\n\n      button {\n        all: unset;\n        background-color: var(--accentColor);\n        color: var(--textOnAcccentColor);\n        padding: 7px 10px;\n        border-radius: 5px;\n        cursor: pointer;  \n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalContainer": `modal_modalContainer__6bxsb`,
	"modal": `modal_modal__XhTq8`,
	"header": `modal_header__oe722`,
	"title": `modal_title__0XpA9`,
	"body": `modal_body__SQUnU`,
	"footer": `modal_footer__GKw2U`
};
export default ___CSS_LOADER_EXPORT___;
